import styled from '@emotion/styled';
import shouldForwardProp from '@styled-system/should-forward-prop';
import { ReactNode } from 'react';
import {
  compose,
  flexbox,
  layout,
  grid,
  GridProps,
  space,
  typography,
  color,
  SpaceProps,
  LayoutProps,
  FlexboxProps,
  TypographyProps,
  ColorProps,
} from 'styled-system';

export interface BoxProps
  extends SpaceProps,
    GridProps,
    LayoutProps,
    FlexboxProps,
    TypographyProps,
    ColorProps {
  children: ReactNode;
}

export const Box = styled('div', { shouldForwardProp })<BoxProps>(
  compose(space, layout, flexbox, typography, color, grid)
);

export const Flex = styled(Box)({
  display: 'flex',
  flexWrap: 'wrap',
});
